import { ApiHeader, ApiQuery, ApiTags } from '@nestjs/swagger';
import { Controller, Post, Body, Logger, Get, UseGuards,Req, Query, Param, Put, Delete} from '@nestjs/common';
import { RolesService } from './roles.services';
import { RolesDTO, RoleStatusUpdateDto, RoleUpdateDto } from './dto/roles.dto';
import { RolesResponseModel } from './dto/roles-response.model';
import { errorHandler } from '@gtpl/shared-utils/error-messages';
import { AllRolesResponseModel } from './dto/all-roles-response.model';

@ApiTags('Roles')
@Controller('roles')
export class RolesController {
    constructor(
        private rolesService: RolesService
    ) {} 

    /* @Post('/createRole')
    async createRole(@Query() queryParams, @Body() rolesDto: RolesDTO, @Req() request:Request): Promise<RolesResponseModel> {
        try {
            if(queryParams.apiVersion == 1){
                return await this.rolesService.createRole(rolesDto, request);
            } else {
                return await this.rolesService.createRole(rolesDto, request);
            }
        } catch (error) {
            return errorHandler(RolesResponseModel, error);
        }        
    } */
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @Get('/getActiveRoles')
    @ApiQuery({name:'apiVersion'})
    async getActiveRoles(@Query() queryParams, @Req() request:Request):Promise<AllRolesResponseModel> {
        try {
            if (queryParams.apiVersion == 1){
                return await this.rolesService.getActiveRoles(request);
            } else {
                return await this.rolesService.getActiveRoles(request);
            }
        } catch (error) {
            return errorHandler(AllRolesResponseModel, error);
        }
    }

    /* @Post('/updateRole')
    async updateRole(@Query() queryParams, @Body() roleUpdateDto: RoleUpdateDto, @Req() request:Request): Promise<RolesResponseModel> {
        try {
            if(queryParams.apiVersion == 1) {
                return await this.rolesService.updateRole(roleUpdateDto, request);
            } else {
                return await this.rolesService.updateRole(roleUpdateDto, request);
            }
        } catch (error) {
            return errorHandler(RolesResponseModel, error);
        }
    } */
     
   /*  @Post('/updateRoleStatus')
    async updateRoleStatus(@Query() queryParams, @Body() roleStatusUpdateDto: RoleStatusUpdateDto, @Req() request: Request): Promise<RolesResponseModel> {
        try {   
            if (queryParams.apiVersion == 1) {
                return await this.rolesService.updateRoleStatus(roleStatusUpdateDto, request);
            } else {
                return await this.rolesService.updateRoleStatus(roleStatusUpdateDto, request);
            }
        } catch (error) {
            return errorHandler(RolesResponseModel, error);
        }
    } */   
    
    @ApiHeader({
        name:'Authorization',
        description:'Authorization token'
    })
    @ApiHeader({
        name:'roleid',
        description:'user roleid'
    })
    @Get('/getNextLevelRoles')
    @ApiQuery({name:'apiVersion'})
    async getAllRolesByLevel(@Query() queryParams, @Req() request:Request):Promise<AllRolesResponseModel> {
        try {
            return await this.rolesService.getAllRolesByLevel(queryParams, request);
        } catch (error) {
            return errorHandler(AllRolesResponseModel, error);
        }
    }
}
